import { keepPreviousData, useQuery } from '@tanstack/react-query';

import useLastRefreshedAt from '@/common/hooks/useLastRefreshedAt';
import { createDefaultPaginated } from '@/common/types/paginated';
import { omitEmpty } from '@/common/utils/ObjectFormatters';

import {
  BillingFilters,
  BillingSummary,
  fetchPaginatedBillingsSummary,
  PaginationParams,
} from '../api/FetchBillingList';

export const useFetchPaginatedBillingsSummary = (
  pagination: PaginationParams,
  filters?: BillingFilters,
) => {
  const normalizedFilters = omitEmpty(filters);

  const { data, isLoading, error, refetch, dataUpdatedAt } = useQuery({
    queryKey: ['billings', pagination, normalizedFilters],
    queryFn: ({ signal }) =>
      fetchPaginatedBillingsSummary(pagination, normalizedFilters, signal),
    throwOnError: true,
    placeholderData: keepPreviousData,
    refetchInterval: 30000,
  });

  const lastRefreshedAt = useLastRefreshedAt(dataUpdatedAt);

  const paginatedBillings = data || createDefaultPaginated<BillingSummary>();

  return {
    paginatedBillings,
    isLoading,
    error,
    refetch,
    lastRefreshedAt,
  };
};
